import { postEventSongsList, postEventSongsListHost } from "../../../helpers/event_helper.js";

// action
import {eventSongListSuccess, eventSongListError } from "./reducer";
import {authUserManager} from "../../../helpers/api_helper";

export const viewEventSongs = (eventId) => async (dispatch) => {
  try {
    const guestId = authUserManager.getEventGuestId(eventId);

    // Prowadzący czyta listę uwierzytelnioną trasą — tylko ona zwraca dedykacje
    // i notatki wszystkich gości. Gość (albo ktoś, kto dopiero wszedł w link)
    // dostaje wyłącznie swoje.
    const isHost = Boolean(authUserManager.getToken())
      && (authUserManager.isAdmin() || authUserManager.getAdminEventId() === eventId);

    let data;
    if (isHost) {
      try {
        data = await postEventSongsListHost(eventId);
      } catch (hostError) {
        // Wygasła sesja admina nie może zabrać listy — wracamy do widoku gościa.
        data = await postEventSongsList(eventId, guestId !== null ? { id: guestId } : undefined);
      }
    } else {
      data = await postEventSongsList(eventId, guestId !== null ? { id: guestId } : undefined);
    }

    if (data) {
      dispatch(eventSongListSuccess(data));
    }
  } catch (error) {
    dispatch(eventSongListError(error));
  }
};
